import { render, staticRenderFns } from "./td-tertiary.vue?vue&type=template&id=464293c0&scoped=true"
import script from "./td-tertiary.vue?vue&type=script&lang=js"
export * from "./td-tertiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464293c0",
  null
  
)

export default component.exports